import { z } from 'zod';

export const logicalOperatorSchema = z.enum(['and', 'or']);
export const LogicalOperator = logicalOperatorSchema.enum;
export type LogicalOperator = z.infer<typeof logicalOperatorSchema>;

export const logicalOperatorMap: Record<LogicalOperator, string> = {
  and: 'and',
  or: 'or',
};

export const logicalOperatorOptions = logicalOperatorSchema.options.map((value) => ({
  label: logicalOperatorMap[value],
  value,
}));

export const prismaOperatorMap = {
  [LogicalOperator.and]: { logicalOperator: 'AND' as const, relationFilter: 'every' as const, listFilter: 'hasEvery' as const },
  [LogicalOperator.or]: { logicalOperator: 'OR' as const, relationFilter: 'some' as const, listFilter: 'hasSome' as const },
} as const;

export type PrismaOperators = typeof prismaOperatorMap[keyof typeof prismaOperatorMap];

export function getPrismaOperators(logicalOperator: LogicalOperator = LogicalOperator.and): PrismaOperators {
  return prismaOperatorMap[logicalOperator];
}
